import { CommonModule } from '@angular/common';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import * as i0 from "@angular/core";
export class CorrelationMatrixHeatmapModule {
}
CorrelationMatrixHeatmapModule.ɵfac = function CorrelationMatrixHeatmapModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CorrelationMatrixHeatmapModule)(); };
CorrelationMatrixHeatmapModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CorrelationMatrixHeatmapModule });
CorrelationMatrixHeatmapModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, LoadingSymbolModule] });
